export default {
  route: {
    dashboard: 'Tableau de bord',
    documentation: 'Documentation',
    guide: 'Guide',
    market: 'Market',
    users: 'Utilisateurs',
    buyers: 'Buyers',
    wholesalers: 'Wholesalers',
    sellers: 'Sellers',
    caretakers: 'Caretakers',
    orders: 'Commandes',
    customerOrders: 'Commandes clients',
    orderEdit: 'Édition commande',
    giftCards: 'Cartes cadeaux',
    giftCardEdit: 'Édition carte cadeau',
    giftCardCreate: 'Création carte cadeau',
    ursafEvents: 'Événements URSSAF',
    ursafEventEdit: 'Édition événement URSSAF',
    ursafEventCreate: 'Création événement URSSAF',
    countriesAndRegions: 'Pays & Régions',
    countryEdit: 'Édition pays',
    countryCreate: 'Création pays',
    regionEdit: 'Édition région',
    regionCreate: 'Création région',
    rateCards: 'Cartes tarifaires',
    cardPricing: 'Tarification carte',
    rates: 'Taux',
    cards: 'Cartes',
    purchaseInfos: 'Informations d\'achat',
    purchaseInfosEdit: 'Édition informations d\'achat',
    purchaseInfosCreate: 'Création informations d\'achat',
    giftCardSellers: 'GiftCard Sellers',
    customers: 'Clients',
    advertisers: 'Advertisers',
    wallet: 'Wallet',
    sorewards: 'Sorewards',
    sorewardsPrograms: 'Programmes',
    sorewardsProgramCreate: 'Création programme Sorewards',
    sorewardsProgramShow: 'Programme Sorewards',
    sorewardsSettings: 'Paramètres',
    sorewardsLoadTransactions: 'Chargements',
    sorewardsIssueTransactions: 'Émissions',
    categories: 'Catégories',
    skus: 'Skus',
    skuEdit: 'Sku édition',
    skuCreate: 'Sku création',
    deliveries: 'Livraisons',
    paymentModes: 'Modes de paiement',
    invoices: 'Factures',
    invoiceEdit: 'Édition facture',
    bankTransfers: 'Virements bancaires',
    balances: 'Balances',
    permission: 'Permission',
    pagePermission: 'Page Permission',
    rolePermission: 'Role Permission',
    directivePermission: 'Directive Permission',
    icons: 'Icons',
    components: 'Components',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: 'Mixin',
    backToTop: 'Haut de page',
    draggableDialog: 'Draggable Dialog',
    draggableKanban: 'Draggable Kanban',
    draggableList: 'Draggable List',
    draggableSelect: 'Draggable Select',
    example: 'Example',
    nested: 'Nested Routes',
    table: 'Table',
    dynamicTable: 'Tableau dynamique',
    draggableTable: 'Tableau déplaçable',
    inlineEditTable: 'Inline Edit Table',
    complexTable: 'Complex Table',
    tab: 'Tab',
    form: 'Form',
    errorPages: 'Pages d\'erreur',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Exporter Excel',
    selectExcel: 'Exporter la sélection',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: 'Theme',
    clipboard: 'Presse-papiers',
    i18n: 'I18n',
    externalLink: 'Lien externe',
    profile: 'Profil',
    browseAndGo: 'Modèles d\'opération et de programmes',
    browseAndGoMenu: 'Modèles',
    bngOverview: 'Vue d\'ensemble',
    bngUrssaf: 'Modèles d\'opérations URSSAF',
    bngUrssafMenu: 'URSSAF',
    bngOther: 'Modèles d\'opérations autres',
    bngOtherMenu: 'Autres opérations',
    bngCards: 'Modèles de cartes multi-choix',
    bngCardsMenu: 'Cartes multi-choix',
    bngCardEdit: 'Édition d\'un modèle de carte multi-choix',
    bngCardCreate: 'Création d\'un modèle de carte multi-choix',
    bngBenefits: 'Modèles de Programmes Avantages',
    bngBenefitsMenu: 'Avantages',
    bngBenefitEdit: 'Édition d\'un modèle de Programme Avantages',
    bngBenefitCreate: 'Création d\'un modèle de Programme Avantages',
    bngSelections: 'Sélections d\'enseignes',
    bngSelectionsMenu: 'Sélections',
    bngSelectionEdit: 'Édition d\'une sélection d\'enseignes',
    bngSelectionCreate: 'Création d\'une sélection d\'enseignes',
    bngAssignments: 'Affectations',
    bngOperationEdit: 'Édition d\'un modèle d\'opération',
    bngOperationCreate: 'Création d\'un modèle d\'opération'
  },
  navbar: {
    logOut: 'Déconnexion',
    dashboard: 'Tableau de bord',
    theme: 'Theme',
    profile: 'Profil'
  },
  login: {
    title: 'Login Form',
    logIn: 'Login',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Ou se connecter avec',
    thirdpartyTips: 'Ne peut pas être simulé en local, donc veuillez combiner votre propre simulation d\'entreprise !'
  },
  permission: {
    createRole: 'Nouveau rôle',
    editPermission: 'Édition',
    roles: 'Vôtre rôle',
    switchRoles: 'Changer de rôle',
    tips: 'Dans certains cas, l\'utilisation de v-permission n\'aura aucun effet. Par exemple : Element-UI el-tab ou el-table-column et d\'autres scènes qui rendent dynamiquement le dom. Vous ne pouvez le faire qu\'avec v-if',
    delete: 'Supprimer',
    confirm: 'Confirmer',
    cancel: 'Annuler'
  },
  order: {
    title: 'Commandes acheteur',
    bulk: 'Commandes groupées',
    invoice: 'Facture(s) fournisseur'
  },
  invoice: {
    title: 'Facture(s) acheteur',
    bulk: 'Facture(s) fournisseur'
  },
  ursafEvents: {
    empty: 'Aucun événement URSSAF',
    activeYes: 'Actif',
    activeNo: 'Inactif',
    fields: {
      code: 'Code',
      name: 'Nom',
      cseKind: 'Type CSE',
      defaultDotationDuration: 'Durée de dotation par défaut',
      active: 'Actif',
      multiChoiceGiftCard: 'Carte multi-choix',
      createdAt: 'Créé le',
      updatedAt: 'Mis à jour le'
    },
    filters: {
      name: 'Nom',
      active: 'Statut'
    },
    placeholders: {
      code: 'Ex: christmas',
      name: 'Ex: Noël',
      cseKind: 'Sélectionnez un type CSE',
      defaultDotationDuration: 'Ex: P1Y',
      multiChoiceGiftCard: 'Rechercher une carte multi-choix'
    },
    cseKinds: {
      no_cse: 'Sans CSE',
      social_cse: 'CSE social',
      budget_cse: 'CSE budget'
    },
    validation: {
      code: 'Le code est obligatoire',
      name: 'Le nom est obligatoire',
      cseKind: 'Le type CSE est obligatoire',
      multiChoiceGiftCard: 'La carte multi-choix est obligatoire'
    },
    form: {
      createTitle: 'Création d\'un événement URSSAF',
      editTitle: 'Événement URSSAF — {name}',
      create: 'Créer',
      update: 'Mettre à jour',
      back: 'Retour'
    },
    notifications: {
      createdTitle: 'Événement URSSAF créé',
      createdMessage: 'L\'événement URSSAF a été créé avec succès',
      updatedTitle: 'Événement URSSAF mis à jour',
      updatedMessage: 'L\'événement URSSAF a été mis à jour avec succès'
    }
  },
  sorewardsPrograms: {
    empty: 'Aucun programme Sorewards',
    fields: {
      name: 'Nom',
      programType: 'Type',
      sorewardsProgramId: 'ID programme Sorewards',
      createdAt: 'Créé le',
      updatedAt: 'Mis à jour le'
    },
    filters: {
      name: 'Nom'
    },
    placeholders: {
      name: 'Ex: Programme Noël 2026',
      programType: 'Sélectionnez un type de programme'
    },
    families: {
      PROFID: 'Prime de fidélité',
      CHCOMA: 'Challenge commercial',
      PARRAI: 'Parrainage',
      INCINT: 'Incentive / intéressement',
      OEUSOC: 'Œuvres sociales',
      CE: 'CSE / comité d\'entreprise',
      NOELA: 'Noël',
      NOELE: 'Noël (enfants)',
      RETR: 'Départ à la retraite',
      FETPAR: 'Fête des parents',
      MARPAC: 'Mariage / PACS',
      CV: 'Chèques-vacances',
      SCO: 'Rentrée scolaire',
      NAIS: 'Naissance',
      CC: 'Chèques cadeaux',
      FL: 'Fleurs',
      AUTRES: 'Autres',
      TOP_UP: 'Recharge'
    },
    validation: {
      name: 'Le nom est obligatoire',
      programType: 'Le type de programme est obligatoire'
    },
    form: {
      createTitle: 'Création d\'un programme Sorewards',
      showTitle: 'Programme Sorewards — {name}',
      create: 'Créer',
      back: 'Retour',
      creatingHint: 'La création appelle Sorewards et peut prendre quelques secondes'
    },
    notifications: {
      createdTitle: 'Programme Sorewards créé',
      createdMessage: 'Le programme Sorewards a été créé avec succès'
    }
  },
  sorewardsConsole: {
    tabs: {
      standard: 'Tarifs standard',
      negotiated: 'Tarifs négociés',
      programs: 'Programmes'
    },
    stdTitle: 'Tarifs standard',
    stdDesc: 'Grille appliquée par défaut à tout caretaker sans accord particulier. Montants hors taxes, en euros.',
    issuance: 'Émission de carte',
    shipping: 'Expédition',
    loading: 'Chargement',
    physCard: 'Carte physique',
    virtCard: 'Carte virtuelle',
    shipUnit: 'Expédition unitaire',
    shipGroup: 'Expédition groupée',
    loadFee: 'Frais fixe par chargement',
    loadPct: 'Commission sur le montant chargé',
    perCard: 'par carte',
    perParcel: 'par colis',
    perLoad: 'par chargement',
    ofAmount: 'du montant',
    groupNote: 'à partir de 25 cartes envoyées à une même adresse',
    edit: 'Modifier',
    save: 'Enregistrer',
    cancel: 'Annuler',
    saved: 'Tarifs enregistrés',
    negoTitle: 'Tarifs négociés',
    negoDesc: 'Grille spécifique appliquée à un caretaker à la place des tarifs standard, sur la période convenue.',
    addNego: 'Ajouter un accord',
    caretaker: 'Caretaker',
    validUntil: 'Valable jusqu\'au',
    noNego: 'Aucun tarif négocié',
    noNegoSub: 'Ajoutez un accord pour appliquer une grille spécifique à un caretaker.',
    deleteConfirm: 'Supprimer cet accord tarifaire ?',
    caretakerRequired: 'Le caretaker est obligatoire',
    validUntilRequired: 'La date de fin est obligatoire',
    progTitle: 'Programmes Sorewards et correspondance Privipass',
    progDesc: 'Chaque famille de programme Sorewards est rattachée à un code Privipass qui détermine les catégories de dépense ouvertes sur la carte.',
    progName: 'Programme Sorewards',
    privipass: 'Code Privipass',
    allowedType: 'Type de dotation',
    ceiling: 'Plafond exonéré',
    validity: 'Validité',
    status: 'Statut',
    months: 'mois',
    active: 'Actif',
    draft: 'Brouillon',
    progPending: 'Le détail de la correspondance Privipass reste à confirmer côté émetteur. Les codes ci-dessous sont provisoires.',
    filters: 'Filtres',
    reset: 'Réinitialiser',
    exportCsv: 'Exporter en CSV',
    dateFrom: 'Début',
    dateTo: 'Fin',
    allCaretakers: 'Tous les caretakers',
    searchCaretaker: 'Rechercher un caretaker',
    rowsOf: '{count} ligne sur {total} | {count} lignes sur {total}',
    totalLoaded: 'Montant chargé',
    totalRemaining: 'Solde restant',
    cardsCount: 'Cartes concernées',
    totalLoadCost: 'Coût des chargements',
    totalIssueCost: 'Coût des émissions',
    cardsIssued: 'Cartes émises',
    physCount: 'Physiques',
    virtCount: 'Virtuelles',
    noResults: 'Aucune transaction',
    noResultsSub: 'Aucune ligne ne correspond aux filtres. Élargissez la période ou effacez un critère.',
    idDistribution: 'Id distribution',
    operation: 'Opération',
    dotationOrder: 'Commande de dotation',
    program: 'Programme',
    dotationType: 'Type de dotation',
    dotationDate: 'Émission dotation',
    loadDate: 'Date de chargement',
    loadRef: 'Réf. commande de chargement',
    expiry: 'Expiration',
    amount: 'Montant',
    beneficiary: 'Bénéficiaire',
    cardId: 'Id carte',
    remaining: 'Solde restant',
    loadCost: 'Coût du chargement',
    issuePrice: 'Prix de l\'émission',
    coverLoad: 'Prise en charge',
    coverIssue: 'Prise en charge',
    issueDate: 'Émission carte',
    cardNumber: 'Numéro de carte',
    cardType: 'Type de carte',
    multi: 'Multi',
    mono: 'Mono',
    physical: 'Physique',
    virtual: 'Virtuelle',
    caretakerShare: 'dont caretaker',
    negoLegend: 'Le point doré signale un montant calculé sur un tarif négocié.',
    stdApplied: 'Tarif standard',
    negoApplied: 'Tarif négocié',
    loadTitle: 'Transactions de chargement',
    issueTitle: 'Transactions d\'émission',
    operations: {
      NOELA: 'Noël 2025 — Salariés',
      SCO: 'Rentrée 2026',
      NAIS: 'Naissances T1 2026',
      MARPAC: 'Mariages 2026',
      CV: 'Chèques vacances été',
      RETR: 'Départs en retraite 2026'
    }
  },
  table: {
    title: 'Titre',
    importance: 'Importance',
    type: 'Type',
    remark: 'Remarque',
    search: 'Recherche',
    add: 'Ajouter',
    export: 'Exporter',
    reviewer: 'Reviewer',
    id: 'ID',
    date: 'Date',
    author: 'Auteur',
    readings: 'Lectures',
    status: 'Statut',
    actions: 'Actions',
    edit: 'Édition',
    publish: 'Publier',
    draft: 'Brouillon',
    delete: 'Supprimer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    email: 'E-mail',
    name: 'Nom',
    firstname: 'Prénom',
    lastname: 'Nom de famille',
    password: 'Mot de passe',
    passwordConfirmation: 'Confirmer le mot de passe',
    confirmedAt: 'Confirmé le',
    skuDiscardTooltip: 'Un SKU ayant du stock ne peut pas être archivé',
    skuNotDiscardableTooltip: 'Une fois réactivé, ce SKU ne pourra plus être archivé car il contient du stock'
  },
  wallet: {
    usageStatus: {
      unused: 'Inutilisé',
      partially_used: 'Partiellement utilisé',
      used: 'Utilisé',
      archived: 'Archivé'
    }
  },
  errorLog: {
    tips: 'Veuillez cliquer sur l\'icône "Bug" dans le coin supérieur droit',
    description: 'Maintenant le système de gestion sont essentiellement la forme du spa, il améliore l\'expérience de l\'utilisateur, mais il augmente également la possibilité de problèmes de page, une petite négligence peut conduire à la page entière impasse. Heureusement Vue fournit un moyen d\'attraper les exceptions de manipulation, où vous pouvez gérer les erreurs ou signaler les exceptions.',
    documentation: 'Introduction au document'
  },
  excel: {
    export: 'Exporter',
    selectedExport: 'Exporter les éléments sélectionnés',
    placeholder: 'Veuillez saisir le nom du fichier (excel-list par défaut)'
  },
  zip: {
    export: 'Exporter',
    placeholder: 'Veuillez saisir le nom du fichier'
  },
  theme: {
    change: 'Changer de thème'
  },
  tagsView: {
    refresh: 'Rafraîchir',
    close: 'Fermer',
    closeOthers: 'Fermer les autres',
    closeAll: 'Tout fermer'
  },
  settings: {
    title: 'Paramètres du style de la page',
    theme: 'Couleur du thème',
    showTagsView: 'Afficher les Tags-View',
    showSidebarLogo: 'Logo de la barre latérale',
    fixedHeader: 'En-tête fixe',
    sidebarTextTheme: 'Thème de texte de la barre latérale'
  }
}
